import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[bix-popper-close]'
})
export class BixPopperCloseDirective {

  constructor() { }

  @HostListener('click', ['$event']) onClick(event: any) {

    let isBixPopoevrActive = document.getElementById('bixPopover');

    if (isBixPopoevrActive !== null) {
      isBixPopoevrActive.remove();
    }
  }


}
